
const INITIAL_STATE = {
    confirmations: [],
    mviList: [],
    confirmation: {},
    labels: [],
    label: {},
    mvis: [],
    mvi: {},
    filter: {},
    receiptStorage: [],
    resourceMvi: {},
    receipts: [],
    selectedTab: 0,
    transmissions: {},
    drivers: [],
    vehiclePlates: [],
    highCostMaterial: {},
    highCostMaterials: {},
    shedArea: {},
    shedAreaPaged: {}
};

export default function truckKanbanReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }
    switch (action.type) {
        case 'SET_HIGH_COST_MATERIALS': {
            return {
                ...state,
                highCostMaterials: action.highCostMaterials,
            }
        }
        case 'SET_HIGH_COST_MATERIAL': {
            return {
                ...state,
                highCostMaterial: action.highCostMaterial,
            }
        }
        case 'SET_ACTIVE_TAB_TRUCK_KANBAN': {
            return {
                ...state,
                selectedTab: action.activeTab,
            };
        }
        case 'ADD_LABEL': {
            let labelsList = [];
            Object.assign(labelsList, state.labels);

            labelsList.push(action.label);
            return {
                ...state,
                labels: labelsList
            };
        }
        case 'REMOVE_LABEL': {
            let labelsList = [];
            Object.assign(labelsList, state.labels);
            labelsList = labelsList?.filter((i) => i.id !== action.label.id);
            return {
                ...state,
                labels: labelsList
            };
        }

        case 'CLEAR_LABEL': {
            return {
                ...state,
                labels: INITIAL_STATE.labels
            };
        }

        case 'ADD_MVI_ITEM': {
            const mviList = [];
            Object.assign(mviList, state.mvis);
            mviList.push(action.mvi);
            return {
                ...state,
                mvis: mviList
            };
        }
        case 'UPDATE_TRUCK_KANBAN': {
            let receiptState = [];
            Object.assign(receiptState, action.receipts);
            return {
                ...state,
                receipts: receiptState
            };
        }
        case 'UPDATE_MVI': {
            let mviListState = [];
            Object.assign(mviListState, action.mviList);
            return {
                ...state,
                mviList: mviListState
            };
        }
        case 'UPDATE_LABELS_TRUCK_KANBAN': {
            let receiptState = [];
            Object.assign(receiptState, action.labels);
            return {
                ...state,
                labels: receiptState
            };
        }
        case 'UPDATE_RECEIPT_TRUCK_KANBAN': {
            const receipts = [];
            Object.assign(receipts, state.receipts);
            const receipt = receipts.find((o) => o.id === action.receipt.id);
            if (receipt) {
                Object.assign(receipt, action.receipt);
            }
            return {
                ...state,
                receipts: receipts
            };
        }
        case 'UPDATE_RECEIPT_MASSIVE_INDICATOR_TK': {
            const receipts = [];
            Object.assign(receipts, state.receipts);
            const receipt = receipts.find((i) => { return i.id === action.id; });
            if (receipt !== undefined) {
                receipt.massiveReceiptIndicator = action.value;
            }
            return {
                ...state,
                receipts: receipts
            };
        }
        case 'SET_RESOURCE_MVI_TRUCK_KANBAN': {
            return {
                ...state,
                resourceMvi: action.resourceMvi,
            };
        }
        case 'RESET_CONFIRMATION_TRUCK_KANBAN': {
            return {
                ...state,
                confirmation: INITIAL_STATE.confirmation,
            };
        }

        case 'CREATE_CONFIRMATION_TRUCK_KANBAN':
            return {
                ...state,
                confirmation: action.confirmation,
            };
        case 'INSERT_NEW_CONFIRMATION_TRUCK_KANBAN':
            return {
                ...state,
                confirmations: [...state.confirmations, action.confirmation],
            };
        case 'DECREASE_RECEIPT_BALANCE_TRUCK_KANBAN': {
            let receiptItem = [];
            Object.assign(receiptItem, state.receipts);
            const item = receiptItem?.find((i) => { return i.partNumberCode === action.partNumberCode; });
            if (item) {
                item.balance -= action.value;
                if (item.qtPartnumbers && item.qme > 0) {
                    item.qtPartnumbers = item.balance / item.qme;
                }
            }
            return {
                ...state,
                receipts: receiptItem,
            };
        }
        case 'CLEAR_TRUCK_KANBAN': {
            return {
                ...state,
                confirmations: INITIAL_STATE.confirmations,
                confirmation: INITIAL_STATE.confirmation,
                receiptStorage: INITIAL_STATE.receiptStorage,
                receipts: INITIAL_STATE.receipts,
                selectedTab: INITIAL_STATE.selectedTab,
                filter: INITIAL_STATE.filter,
                labels: INITIAL_STATE.labels,
                mvis: INITIAL_STATE.mvis,
                mvi: INITIAL_STATE.mvi
            };
        }
        case 'SET_FILTER_TRUCK_KANBAN':
            return {
                ...state,
                filter: action.filter,
            };
        case 'SET_TRANSMISSIONS':
            return {
                ...state,
                transmissions: action.transmissions,
            };
        case 'SELECT_TRANSMISSION':
            return {
                ...state,
                transmission: action.transmission,
            }
        case 'ADD_DRIVER': {
            const drivers = [];

            if (state.drivers.length >= 3) {
                const last3 = []
                const lgt = state.drivers.length

                for (let i = lgt - 2; i < lgt; i += 1) {
                    last3.push(state.drivers[i])
                }

                Object.assign(drivers, last3);
            }
            else {
                Object.assign(drivers, state.drivers);
            }

            drivers.push(action.driver);
            return {
                ...state,
                drivers: drivers
            };
        }
        case 'ADD_VEHICLEPLATE': {
            const vehiclePlates = [];

            if (state.vehiclePlates.length >= 3) {
                const last3 = []
                const lgt = state.vehiclePlates.length

                for (let i = lgt - 2; i < lgt; i += 1) {
                    last3.push(state.vehiclePlates[i])
                }

                Object.assign(vehiclePlates, last3);
            }
            else {
                Object.assign(vehiclePlates, state.vehiclePlates);
            }

            vehiclePlates.push(action.vehiclePlate);
            return {
                ...state,
                vehiclePlates: vehiclePlates
            };
        }
        case 'SET_SHED_AREA': {
            return {
                ...state,
                shedArea: action.shedArea
            };
        }
        case 'SET_SHED_AREA_PAGED': {
            return {
                ...state,
                shedAreaPaged: action.shedAreaPaged
            };
        }
        default:
            return state;
    }
}
